import {
  translate,
  generateRules,
  generatePinyin,
  processGrammar,
  getRuleMappings,
  getRuleMappingSentences,
  updatePageTranslations,
  createRuleMapping,
  createRuleMappingSentence,
  randomRules,
} from 'utils/queries/grammar';

export const grammarEndpoints = (build) => ({
  translate: build.query({
    query: (input) => ({
      method: 'POST',
      body: JSON.stringify({
        query: translate,
        variables: { input },
      }),
    }),
    transformResponse: (response) => response.data.translate,
  }),

  generateRules: build.query({
    query: (input) => ({
      method: 'POST',
      body: JSON.stringify({
        query: generateRules,
        variables: { input },
      }),
    }),
    transformResponse: (response) => response.data.generateRules,
  }),

  generatePinyin: build.query({
    query: (input) => ({
      method: 'POST',
      body: JSON.stringify({
        query: generatePinyin,
        variables: { input },
      }),
    }),
    transformResponse: (response) => response.data.generatePinyin,
  }),

  processGrammar: build.query({
    query: ({ parseString, parseType }) => ({
      method: 'POST',
      body: JSON.stringify({
        query: processGrammar,
        variables: { parseString, parseType },
      }),
    }),
    transformResponse: (response) => response.data.processGrammar,
  }),

  getRuleMappings: build.query({
    query: (args) => ({
      method: 'POST',
      body: JSON.stringify({
        query: getRuleMappings,
        variables: args,
      }),
    }),
    transformResponse: (response) => response.data.getRuleMappings,
  }),

  getRuleMappingSentences: build.query({
    query: (args) => ({
      method: 'POST',
      body: JSON.stringify({
        query: getRuleMappingSentences,
        variables: args,
      }),
    }),
    transformResponse: (response) => response.data.getRuleMappingSentences,
  }),

  getRandomRules: build.query({
    query: ({ rulesStr, count }) => ({
      method: 'POST',
      body: JSON.stringify({
        query: randomRules,
        variables: { rulesStr, ...(count !== undefined && { count }) },
      }),
    }),
    transformResponse: (response) => response.data.randomRules,
  }),

  updatePageTranslations: build.mutation({
    query: () => ({
      method: 'POST',
      body: JSON.stringify({
        query: updatePageTranslations,
      }),
    }),
    transformResponse: (response) => response.data.updatePageTranslations,
  }),

  createRuleMapping: build.mutation({
    query: (input) => ({
      method: 'POST',
      body: JSON.stringify({
        query: createRuleMapping,
        variables: { input },
      }),
    }),
    transformResponse: (response) => response.data.createRuleMapping,
  }),

  createRuleMappingSentence: build.mutation({
    query: (input) => ({
      method: 'POST',
      body: JSON.stringify({
        query: createRuleMappingSentence,
        variables: { input },
      }),
    }),
    transformResponse: (response) => response.data.createRuleMappingSentence,
  }),
});
